import React from 'react';
import PropTypes from 'prop-types';
import ProductImage from '../../../utils/productItem/productImage';

const { locale } = window.inlineGlobalConfig;

const ProductCard = ({ product, languageCulture }) => {
  if (!product) return null;

  const formatPrice = value => {
    if (typeof value !== 'number') return null;
    return new Intl.NumberFormat(languageCulture || 'en-GB', {
      style: 'currency',
      currency: product.price.symbol,
    }).format(value);
  };

  return (
    <div className="carousel-cell">
      <a href={`/${locale.country}/${locale.language}${product.url}`}>
        <div className="product-carousel__image-container">
          <ProductImage
            product={{
              heroImage: product.imageSet?.[0],
              altImage: product.imageSet?.[1],
              imageAlt: product.name,
              name: product.name,
            }}
          />
        </div>

        <div className="product-meta__container">
          <span className="product-meta__tile">{product.name}</span>

          <div>
            {product?.wasPrice && (
              <span className="product-meta__was-price">{formatPrice(product.wasPrice.value)}</span>
            )}
            <span className={`product-meta${product?.wasPrice ? '__now-price' : '__price'}`}>
              {formatPrice(product.price.value)}
            </span>
          </div>
        </div>
      </a>
    </div>
  );
};

ProductCard.propTypes = {
  product: PropTypes.shape({
    url: PropTypes.string.isRequired,
    name: PropTypes.string,
    description: PropTypes.string,
    price: PropTypes.shape({
      value: PropTypes.number,
      symbol: PropTypes.string,
    }),
    wasPrice: PropTypes.shape({
      value: PropTypes.number,
      symbol: PropTypes.string,
    }),
    images: PropTypes.arrayOf(
      PropTypes.shape({
        imageType: PropTypes.string,
        url: PropTypes.string,
      })
    ),
  }).isRequired,
};

export default ProductCard;
